import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Header } from "./common-components/Header";
import { Footer } from "./common-components/Footer";
import { Main } from "./components/main";
import SplashScreen from "./splashscreen/SplashScreen";
import Scrolltotop from "./Sctolltotop";
import { Alumni } from "./components/pages/Alumni";
import { Campus } from "./components/campus/Campus";
import { CampusPlaygroundDetails } from "./components/campus/Campus-playgrounddetails";
import { CampusFitnessDetails } from "./components/campus/Campus-fitnessdetails";
import { CampusMessDetails } from "./components/campus/Campus-messdetails";
import { CampusStudioDetails } from "./components/campus/Campus-studiodetails";
import { CampusLibraryDetails } from "./components/campus/Campus-librarydetails";
import { CampusHostelDetails } from "./components/campus/Campus-hosteldetails";
import { Staff } from "./components/academics/Staff";
import { StaffDetails } from "./components/utils/Staff-details";
import { Carrers } from "./components/careers/Carrers";
import { CarrersDetails } from "./components/careers/Carrers-details";
import { StudentStoryDetails } from "./components/academics/Student-story-details";
import { About } from "./components/pages/About";
import { Achievements } from "./components/pages/Achievements";
import { Undergraduate } from "./components/academics/Undergraduate";
import { Postgraduate } from "./components/academics/Postgraduate";
import { Diploma } from "./components/academics/Diploma";
import { InternationalStudent } from "./components/pages/International-student";
import { MArchApplication } from "./components/academics/March-application";
import { BArchApplication } from "./components/academics/Barch-application";
import { DiplomaApplication } from "./components/academics/Diploma-application";
import { Gallery } from "./components/pages/Gallery";
import { Placement } from "./components/careers/Placement";
import { News } from "./components/pages/News";
import { Events } from "./components/pages/Events";
import { NewsDetails } from "./components/utils/News-details";
import { EventDetails } from "./components/utils/Event-details";
import { Contact } from "./common-components/Contact";
import PayamentCard from "./components/rezor/PayamentCard";
import SuccessPage from "./components/rezor/SuccessPage";
import Cancel from "./components/rezor/Cancel";
import SuccessPageNotPlan from "./components/rezor/SuccessPageNotPlan";
import WelcomeCard from "./components/rezor/WelcomeCard";
import CookieConsent from "./components/policies/CookieConsent";
import CookieConsentComponent from "./components/policies/CookieConsent";
import { Registration } from "./components/utils/Registration";
import { Announcement } from "./components/pages/Announcement";
import { StatusPopup } from "./components/pages/StatusPopup";
import { AdmissionPopup } from "./components/pages/AdmissionPopup";
import { Helmet } from "react-helmet";
import TermsConditions from "./components/policies/Terms-conditions";
import PrivacyPolicy from "./components/policies/Privacy-policy";
import { Academic } from "./components/academics/Academic";
import MarchUrban from "./components/utils/March-urban";
import { Blog } from "./components/pages/Blogs";
import { BlogDetails } from "./components/utils/Blogs-details";
import { getapporveldocs } from "./server/apihelper";
import { useState, useEffect } from "react";
import MediaHub from "./components/pages/Mcgansmediahub";
import GTMTracker from "./GTMTracker";
const API_URL = process.env.REACT_APP_API_URL;
// import { ThemeToggle } from "./togglethemebar/toggletheme";
function App() {
  // Approval Modal State and Handler
  const [showApprovalModal, setShowApprovalModal] = React.useState(false);
  const [selectedPDF, setSelectedPDF] = React.useState(0);
  const [approvalPDFs, setApprovalPDFs] = useState([]);
  useEffect(() => {
    const fetchApprovalDocs = async () => {
      try {
        const data = await getapporveldocs();
        setApprovalPDFs(data);
      } catch (err) {
        console.error("Error fetching approval documents:", err);
      }
    };

    fetchApprovalDocs();
  }, []);

  // Open modal and set first PDF as selected
  const handleApprovalClick = () => {
    setShowApprovalModal(true);
    setSelectedPDF(0);
  };

  // Close modal
  const closeApprovalModal = () => setShowApprovalModal(false);
  return (
    <div className="App">
      {/* <Suspense fallback={<div>Loading...</div>}></Suspense> */}
      <Suspense fallback={<SplashScreen />}>
        <BrowserRouter>
          <GTMTracker />
          <Header
            showApprovalModal={showApprovalModal}
            setShowApprovalModal={setShowApprovalModal}
            approvalPDFs={approvalPDFs}
            handleApprovalClick={handleApprovalClick}
            closeApprovalModal={closeApprovalModal}
            selectedPDF={selectedPDF}
            setSelectedPDF={setSelectedPDF}
          />
          {/* <Announcement /> */}
          <Scrolltotop />
          <CookieConsentComponent />

          <Routes>
            {/* Home */}
            <Route
              path="/"
              element={
                <>
                  <Announcement />
                  {/* <StatusPopup /> */}
                  {/* <AdmissionPopup /> */}
                  <Main />
                </>
              }
            />
            {/*Alumni */}
            <Route path="/alumni" element={<Alumni />} />
            {/*Campus */}
            <Route path="/campus" element={<Campus />} />
            <Route
              path="/campus-playgrounddetails"
              element={<CampusPlaygroundDetails />}
            />
            <Route
              path="/campus-fitnessdetails"
              element={<CampusFitnessDetails />}
            />
            <Route path="/campus-messdetails" element={<CampusMessDetails />} />
            <Route
              path="/campus-studiodetails"
              element={<CampusStudioDetails />}
            />
            <Route
              path="/campus-librarydetails"
              element={<CampusLibraryDetails />}
            />
            <Route
              path="/campus-hosteldetails"
              element={<CampusHostelDetails />}
            />
            <Route path="/staff" element={<Staff />} />
            <Route path="/staff-details/:id" element={<StaffDetails />} />
            {/*Careers */}
            <Route path="/careers" element={<Carrers />} />
            <Route path="/careers-details/:id" element={<CarrersDetails />} />
            {/*Student Story */}
            <Route
              path="/student-story-details"
              element={<StudentStoryDetails />}
            />
            {/* Home */}
            {/* <Route path="/" element={<Main />} /> */}
            {/* About */}
            <Route path="/about-us" element={<About />} />
            {/* Achievements */}
            <Route path="/achievements" element={<Achievements />} />
            {/* Acdamic */}
            <Route path="/undergraduate" element={<Undergraduate />} />
            <Route path="/postgraduate" element={<Postgraduate />} />
            <Route path="/diploma" element={<Diploma />} />
            <Route
              path="/international-student"
              element={<InternationalStudent />}
            />
            {/* Application */}
            <Route path="/march-application" element={<MArchApplication />} />
            <Route path="/barch-application" element={<BArchApplication />} />
            <Route
              path="/diploma-application"
              element={<DiplomaApplication />}
            />
            {/* gallery */}
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/mediahub" element={<MediaHub />} />
            {/* placement */}
            <Route path="/placement" element={<Placement />} />
            {/* News */}
            <Route path="/news" element={<News />} />
            <Route path="/news-details/:id" element={<NewsDetails />} />
            {/* Event */}
            <Route path="/events" element={<Events />} />
            <Route path="/event-details/:id" element={<EventDetails />} />
            {/* {Blogs} */}
            <Route path="/blogs" element={<Blog />} />
            <Route path="/blog-details/:id" element={<BlogDetails />} />
            {/* contect */}
            <Route path="/contact" element={<Contact />} />
            {/* connect now Registration page  */}
            <Route path="/registration" element={<Registration />} />
            {/* Razorpay */}
            <Route path="/" element={<WelcomeCard />} />
            <Route path="/query" element={<PayamentCard />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/failure" element={<SuccessPageNotPlan />} />
            <Route path="/cancel" element={<Cancel />} />
            {/* Announcement */}
            <Route path="/announcement" element={<Announcement />} />
            {/* Terms & Conditions */}
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/campus" element={<Campus />} />
            <Route path="/academic" element={<Academic />} />
            <Route path="/march-urban" element={<MarchUrban />} />
          </Routes>

          <Footer
            handleApprovalClick={handleApprovalClick}
          />
        </BrowserRouter>
        {/* <ThemeToggle /> */}
      </Suspense>

      {/* Approval PDF Modal (Global) */}
      {showApprovalModal && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300,
            overflow: "auto",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "90%",
              maxWidth: "1200px",
              height: "90%",
              background: "white",
              borderRadius: "15px",
              padding: "20px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
              overflow: "hidden",
            }}
          >
            {/* Close Button */}
            <button
              onClick={closeApprovalModal}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                width: "30px",
                height: "30px",
                background: "#bb2a2e",
                color: "white",
                border: "none",
                borderRadius: "50%",
                fontSize: "18px",
                fontWeight: "bold",
                cursor: "pointer",
                zIndex: 1,
              }}
            >
              ✖
            </button>

            {/* Modal Header */}
            <div style={{ marginBottom: "20px", textAlign: "center" }}>
              <h2 style={{ color: "#bb2a2e", marginBottom: "10px" }}>
                Approval Documents
              </h2>
              <p style={{ color: "#666", fontSize: "14px" }}>
                Click on any tab to view the document
              </p>
            </div>

            {/* PDF Links */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px", padding: "20px" }}>
              {approvalPDFs.map((pdf, index) => (
                <div key={index} style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "20px",
                  border: "2px solid #f0f0f0",
                  borderRadius: "10px",
                  backgroundColor: "#fafafa",
                  transition: "all 0.3s ease"
                }}>
                  <div style={{ flex: 1 }}>
                    <h3 style={{
                      color: "#bb2a2e",
                      marginBottom: "10px",
                      fontSize: "18px",
                      fontWeight: "600"
                    }}>
                      {pdf.title}   {/* <-- FIXED HERE */}
                    </h3>
                    <p style={{
                      color: "#666",
                      fontSize: "14px",
                      marginBottom: "0"
                    }}>
                      Click to view the approval document
                    </p>
                  </div>
                  <a
                    href={pdf.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      padding: "12px 24px",
                      background: "#bb2a2e",
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "5px",
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "background-color 0.3s ease"
                    }}
                    onMouseOver={e => e.target.style.backgroundColor = "#a02428"}
                    onMouseOut={e => e.target.style.backgroundColor = "#bb2a2e"}
                  >
                    View PDF
                  </a>
                </div>
              ))}

            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
